/**
 * @file What one bar of a bar card measures: its decimal value, a null value
 * at zero, or its count while the value column is refused, so a bar never
 * reads as zero in place of a refusal. Consumers: `analyticsPipeline` (project
 * counts) and `analyticsReceivableAging` (invoice counts), which pass the
 * measures to `analyticsBarPercents`. A value that is not a decimal measures
 * zero; the models reject such rows before measuring.
 */
import { analyticsDecimalFraction } from '#types';
import type { AnalyticsFraction, NamedQueryRefusedColumn } from '#types';

export const analyticsBarMeasure = (
  value: string | null,
  count: number,
  refusedValue: NamedQueryRefusedColumn | null,
): AnalyticsFraction =>
  refusedValue === null
    ? (analyticsDecimalFraction(value ?? '0') ?? {
        numerator: 0n,
        denominator: 1n,
      })
    : { numerator: BigInt(count), denominator: 1n };
